export enum OfferingTypesEnum {
  Unknown = 0,
  Product = 1,
  Service = 2
}
